// Mount a Vue app and remove its server-rendered fallback once the app has rendered, so the area is never blank
export function mountWithFallback(app, mountTarget, fallbacks) {
    app.mount(mountTarget);

    const removeFallbackWhenReady = () => {
        if (mountTarget.firstElementChild) {
            fallbacks.forEach((fallback) => fallback.remove());
            return;
        }

        window.requestAnimationFrame(removeFallbackWhenReady);
    };
    removeFallbackWhenReady();
}
